module.exports = __webpack_public_path__ + "img/cooperation5.68930071.png";